module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#technology",
      toString: function () {
        return this.url;
      }
    }